class Posts {
}

export default Posts;
